__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/a2d9fa1/_next/";